module.exports = __webpack_public_path__ + "static/media/ptc.c331eef7.png";